<template>
  <div class="container-document-form">
    <!-- Document Information -->
    <div>
      <form-accordion :title="$t('businessDocuments.request_desc')">
        <div class="row">
          <form-read-group-label-input v-if="document.Reference !== ''"
            :inputLabel="$t('common.rfrnc')"
            :inputValue="document.Reference">
          </form-read-group-label-input>
          <form-read-group-label-input v-if="document.DocumentDate !== ''"
            :inputLabel="$t('businessDocuments.creation_date')"
            :inputValue="document.DocumentDate.substring(0, 7)">
          </form-read-group-label-input>
        </div>
        <div class="row">
          <div class="form-group col-sm-6" v-if="document.Description !== ''">
            <label>{{ $t('businessDocuments.request_init_message') }}</label>
            <textarea class="form-control inputAccordionForm" :value="document.Description"
                      style="margin-top: 4px;" disabled>
            </textarea>
          </div>
          <div class="form-group col-sm-6" v-if="document.DecisionMessage !== ''">
            <label>{{ $t('businessDocuments.request_desc_read') }}</label>
            <textarea class="form-control inputAccordionForm" :value="document.DecisionMessage"
                      style="margin-top: 4px;" disabled>
            </textarea>
          </div>
        </div>
      </form-accordion>
      <div class="row justify-content-start" v-if="showDownloadButton(document.Status)">
        <div class="col-md-3 justify-content-start"
          v-if="document.IdSeller">
          <button round
            class="button-action firstButtonMarginTop col-md milkyBlockBlack"
            @click="seeSupplierDetails(document.IdSeller)">
            <i class="icon fa fa-arrow-right"></i>
            {{ $t('businessDocuments.form_document_redirection_button') }}
          </button>
        </div>
        <div class="col-md-3">
          <button round
            class="button-action firstButtonMarginTop col-md milkyBlockBlack"
            @click="downloadBusinessDocument">
            <i class="icon fa fa-download"></i>
            {{ $t('businessDocuments.form_document_download_button') }}
          </button>
          <br/><br/>
        </div>
      </div>
      <form-accordion :title="$t('businessDocuments.doc_details')"
        v-if="document.Serialize != null && Object.keys(document.Serialize).length != 0 && this.serializeGet.length != 0"
        :open="false">
        <div class="row">
          <template v-for="value in serializeGet">
            <template v-if="value.type === 'object'">
              <form-read-group-label-input v-for="(subvalue, subindex) in value[0]"
                :key="subindex"
                :inputLabel="$t('businessDocuments.serialize.' + document.Type + '.' + subindex.name)"
                :inputValue="document.Serialize[value.name][0][subindex.name]">
              </form-read-group-label-input>
            </template>
            <form-read-group-label-input v-else-if="value.type === 'date'"
              :inputLabel="$t('businessDocuments.serialize.' + document.Type + '.' + value.name)"
              :inputValue="document.Serialize[value.name]">
            </form-read-group-label-input>

            <div v-else-if="value.type === 'boolean' && value.change === '0'" class="form-group col-sm-6">
              <label>{{ $t('businessDocuments.serialize.' + document.Type + '.' + value.name) }}</label>

              <div v-if="document.Serialize[value.name] === '0'">
                <i class="icon fa fa-check" style="color:green;font-size:30px;"></i>
                &nbsp;&nbsp;{{ $t('common.status.valid_control_key') }}
              </div>
              <div v-else>
                <i class="icon fa fa-ban" style="color:red;font-size:30px;"></i>&nbsp;&nbsp;
                <span v-if="document.Serialize[value.name] === '1'">
                  {{ $t('errors.invalid_control_key') }}
                </span>
                <span v-else-if="document.Serialize[value.name] === '2'">
                  {{ $t('errors.out_of_date') }}
                </span>
                <span v-else-if="document.Serialize[value.name] === '3'">
                  {{ $t('errors.invalid_control_key_out_of_date') }}
                </span>
              </div>
            </div>
            <form-read-group-label-input v-else
              :inputLabel="$t('businessDocuments.serialize.' + document.Type + '.' + value.name)"
              :inputValue="document.Serialize[value.name]">
            </form-read-group-label-input>
          </template>
        </div>
      </form-accordion>
      <form-accordion :title="$t('businessDocuments.request_history')"
        v-if="document.History != null">
        <div class="row">
          <div class="form-group col-sm-12">
            <table class="table table-striped table-bordered" style="table-layout:fixed">
              <thead>
                <tr>
                  <th>{{ $t('businessDocuments.action_date') }}</th>
                  <th>{{ $t('businessDocuments.doc_status_label') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, index) in document.History">
                  <td>{{ getDateValue(value.date_change) }}</td>
                  <td>{{ getStatusLabel(value.status) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </form-accordion>
    </div>
  </div>
</template>
<script>
import documentSerialize from '@/helpers/documentSerialize.json'
import {errorMessageAlert} from '@/helpers/alert'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import {loadPage} from '@/helpers/routing'
import status from '@/helpers/status'
import {statusLabel} from '@/helpers/labels'

export default {
  name: 'BusinessDocumentReturnForm',
  props: ['document'],
  components: {
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput
  },
  data () {
    return {
      documentNoDocStatusList: [
        status.DOC_REQUEST_ACCEPTED,
        status.DOC_REQUEST_CANCELED,
        status.DOC_REQUEST_OUT_TIME,
        status.DOC_REQUEST_RECEIVED,
        status.DOC_REQUEST_REFUSED,
        status.DOC_REQUEST_REJECTED,
        status.DOC_REQUEST_SENT
      ],
      fileArrayError: false,
      fileContentArray: [],
      fileId: '',
      fileNameLabel: '',
      formMessage: '',
      infosCompl: '',
      locationTypeFile: '1'
    }
  },
  created () {
    // Retrieving types of the document
    this.serializeGet = documentSerialize[this.document.Type].fields
  },
  methods: {
    downloadBusinessDocument () {
      this.$engine.services.businessDocuments.getAttachment(this.document.IdDocument)
      .then(resp => {
        const linkSource = resp.data.document_data
        const downloadLink = document.createElement('a')
        downloadLink.href = linkSource
        downloadLink.download = this.document.Name
        downloadLink.click()
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    getDateValue (date) {
      return date
    },
    getStatusLabel (status) {
      return statusLabel(this.$i18n, 'Doc_' + status, this.document.Role)
    },
    seeSupplierDetails (seller) {
      this.$engine.services.suppliers.selectedSupplier.IdSeller = seller
      loadPage(this, { url: '/suppliers/details/' })
    },
    showDownloadButton (documentStatus) {
      if (this.documentNoDocStatusList.includes('Doc_' + documentStatus)) {
        return false
      }
      return true
    }
  }
}

</script>
